import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("zr_cart") || "[]"); } catch { return []; }
  });
  const [orderType, setOrderType] = useState(() => localStorage.getItem("zr_ordertype") || "delivery");

  useEffect(() => { localStorage.setItem("zr_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("zr_ordertype", orderType); }, [orderType]);

  const add = (key) => setItems((p) => {
    const f = p.find((i) => i.key === key);
    return f ? p.map((i) => (i.key === key ? { ...i, qty: i.qty + 1 } : i)) : [...p, { key, qty: 1, flavor: "", extras: [] }];
  });
  const setMeta = (key, patch) => setItems((p) => p.map((i) => (i.key === key ? { ...i, ...patch } : i)));
  const setQty = (key, qty) => setItems((p) => qty <= 0 ? p.filter((i) => i.key !== key) : p.map((i) => (i.key === key ? { ...i, qty } : i)));
  const remove = (key) => setItems((p) => p.filter((i) => i.key !== key));
  const clear = () => setItems([]);
  const replace = (newItems, type) => { setItems(newItems); if (type) setOrderType(type); };
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, replace, count, orderType, setOrderType, setMeta }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
